import { trim } from 'fp-ts/string';
import { UserManagementFormData } from 'src/modules/common/types/UserManagementFormData';
import { FormRule } from 'src/modules/form/types/FormRule';
import * as R from 'src/modules/form/utils/rules';

export const USER_EDIT_FORM_SCHEMA: FormRule<UserManagementFormData> = R.struct({
  email: R.map(trim, R.allOf([R.nonEmpty(), R.email()])),
  firstName: R.map(trim, R.allOf([R.nonEmpty(), R.maxLength(50)])),
  lastName: R.map(trim, R.allOf([R.nonEmpty(), R.maxLength(50)])),
  role: R.nonEmpty(),
  jobTitle: R.map(trim, R.maxLength(50)),
});
